import { ReactNode } from "react";

import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";

import { colors } from "global/globalStyle";

import BaseLabel from "components/BaseLabel";

import { Container } from "./styles";

interface IBasePasswordInput {
  showPassword: boolean;
  handleClickShowPassword: () => void;
  id?: string;
  ref?: any;
  defaultValue?: string;
  name: string;
  label: string;
  marginBottom?: string;
  marginTop?: string;
  marginLeft?: string;
  marginRight?: string;
  helperText?: ReactNode;
  error?: boolean;
  setError?: React.Dispatch<React.SetStateAction<boolean>>;
  value: string;
  height?: string;
  required?: boolean;
  disabled?: boolean;
  maxLength?: number;
  onChange: (e: string) => unknown;
  autofocus?: boolean;
  autoComplete?: string;
}

export function GeneralPasswordInput({
  id,
  label,
  value,
  onChange,
  showPassword,
  handleClickShowPassword,
  marginBottom,
  marginRight,
  marginLeft,
  marginTop,
  defaultValue,
  name,
  error,
  height,
}: IBasePasswordInput) {
  return (
    <Container
      id={id}
      marginBottom={marginBottom}
      marginTop={marginTop}
      marginLeft={marginLeft}
      marginRight={marginRight}
      height={height}
    >
      <BaseLabel
        marginBottom="6px"
        marginLeft="0px"
        fontSize="12px"
        color={colors.neutral_gray_40}
      >
        {label}
      </BaseLabel>
      <OutlinedInput
        type={showPassword ? "text" : "password"}
        fullWidth
        name={name}
        error={error}
        className="input_outline"
        onChange={(e) => onChange(e.target.value)}
        value={value}
        defaultValue={defaultValue}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleClickShowPassword}
              edge="end"
              disableRipple
            >
              {showPassword ? (
                <VisibilityOffOutlinedIcon
                  data-testid="visibilityOff"
                  id="visibilityOff"
                />
              ) : (
                <VisibilityOutlinedIcon
                  data-testid="visibility"
                  id="visibility"
                />
              )}
            </IconButton>
          </InputAdornment>
        }
      />
    </Container>
  );
}
